import {
  APPLICANT_EVALUATION_STATUSES,
  EVALUATION_ROUND_STATUSES,
} from "./constants";

/** Maps the Company Portal API shapes (PROLINE-2969) onto the vocabulary the
 * existing Evaluations UI expects. The API uses `pending`/`submitted` for both
 * rounds and forms; the UI uses `running`/`completed` for rounds and
 * `pending`/`done` for forms. */

const API_STATUS = { pending: "pending", submitted: "submitted" };

const mapRoundStatus = (status) =>
  status === API_STATUS.submitted
    ? EVALUATION_ROUND_STATUSES.completed
    : EVALUATION_ROUND_STATUSES.running;

const mapFormStatus = (status) =>
  status === API_STATUS.submitted
    ? APPLICANT_EVALUATION_STATUSES.done
    : APPLICANT_EVALUATION_STATUSES.pending;

export const normalizeEvaluationRound = (round = {}) => ({
  id: String(round.id),
  name: round.name || "",
  applicantsCount: round.number_of_applicants ?? 0,
  evaluatedCount: round.number_of_submitted_forms ?? 0,
  remainingApplicants: round.remaining_applicants ?? 0,
  status: mapRoundStatus(round.status),
  startDate: round.created_at || null,
  endDate: round.end_date || null,
  eventId: round.event?.id ?? null,
  eventName: round.event?.name ?? "",
});

export const normalizeEvaluationRounds = (list = []) =>
  list.map(normalizeEvaluationRound);

export const normalizeEvaluationForm = (form = {}) => ({
  id: String(form.id),
  status: mapFormStatus(form.status),
  createdAt: form.created_at || null,
  averageRate: form.average_rate ?? 0,
  evaluationName: form.evaluation_name || "-",
  applicantId: form.applicant?.id ?? null,
  applicantName: form.applicant?.name || "-",
  applicantImage: form.applicant?.image || null,
  zoneId: form.zone?.id != null ? String(form.zone.id) : null,
  zoneName: form.zone?.name || "-",
  roleId: form.role?.id != null ? String(form.role.id) : null,
  role: form.role?.name || "-",
  isSupervisor: Boolean(form.is_supervisor_form),
});

export const normalizeEvaluationForms = (list = []) =>
  list.map(normalizeEvaluationForm);

export const normalizeEvaluationFormDetails = (form = {}) => ({
  ...normalizeEvaluationForm(form),
  comment: form.comment || "",
  overallSatisfactionPercentage: form.overall_satisfaction_percentage ?? 0,
  submitter: form.submitter
    ? {
        id: form.submitter.id,
        name: form.submitter.name || "",
        type: form.submitter.type || "",
      }
    : null,
  questions: (form.evaluation_form_questions || []).map((q) => ({
    id: q.id,
    body: q.body || "",
    rate: q.rate ?? null,
  })),
});
